export type Severity = 'high' | 'medium' | 'low' | 'info';

const COLOUR: Record<Severity, string> = {
  high: 'bg-sunset',
  medium: 'bg-sunrise',
  low: 'bg-sunrise/70',
  info: 'bg-adopt',
};

export function SeverityBar({ severity }: { severity: Severity }) {
  return <span className={`block w-[3px] self-stretch rounded-sm ${COLOUR[severity]}`} />;
}

export function severityRank(s: Severity): number {
  return { high: 0, medium: 1, low: 2, info: 3 }[s];
}
